export default __webpack_public_path__ + "static/media/Nadeem Safi.3754f50f.jpeg";